var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { C } from '#integrations';
import { ICON_SIZES, SpinnerIcon } from '../icons';
import { Typography } from '../Typography';
import { ToggleTestIdFactory } from './interactions';
import { LABEL_POSITIONS, TOGGLE_STATES } from './Toggle.constants';
import styles from './Toggle.module.css';
const STATE_CLASS_MAP = {
    in_progress: {
        disabled: undefined,
        enabled: styles.ToggleInProgress,
    },
    off: {
        disabled: styles.ToggleOFFDisabled,
        enabled: styles.ToggleOFF,
    },
    on: {
        disabled: styles.ToggleONDisabled,
        enabled: styles.ToggleON,
    },
};
const CIRCLE_STATE_CLASS_MAP = {
    in_progress: {
        disabled: undefined,
        enabled: styles.CircleInProgress,
    },
    off: {
        disabled: styles.CircleOFFDisabled,
        enabled: styles.CircleOFF,
    },
    on: {
        disabled: styles.CircleONDisabled,
        enabled: styles.CircleON,
    },
};
const SIZE_CLASS_MAP = {
    big: styles.ToggleBig,
    small: styles.ToggleSmall,
};
const CIRCLE_SIZE_CLASS_MAP = {
    big: styles.CircleBig,
    small: styles.CircleSmall,
};
const CIRCLE_POSITION_CLASS_MAP = {
    in_progress: {
        big: undefined,
        small: undefined,
    },
    off: {
        big: undefined,
        small: undefined,
    },
    on: {
        big: styles.CircleONBig,
        small: styles.CircleONSmall,
    },
};
export const Toggle = ({ ariaLabel, 'data-testid': testid, disabled, label, labelPosition = LABEL_POSITIONS.LEFT, onClick, size = 'big', state, }) => {
    _react_refresh_temp_2();
    const isInProgress = state === TOGGLE_STATES.IN_PROGRESS;
    const [settledState, setSettledState] = useState(isInProgress ? undefined : state);
    if (!isInProgress && state !== settledState) {
        setSettledState(state);
    }
    const handleClick = useCallback(() => {
        const shouldHandle = !disabled && !isInProgress;
        if (shouldHandle) {
            onClick?.(state);
        }
    }, [disabled, isInProgress, onClick, state]);
    const isPressed = settledState === undefined
        ? undefined
        : settledState === TOGGLE_STATES.ON;
    const availability = disabled ? 'disabled' : 'enabled';
    const progressIconSize = size === 'big' ? ICON_SIZES.small : ICON_SIZES.xsmall;
    return (_jsxs("button", { ...(!label && { 'aria-label': ariaLabel }), "aria-busy": isInProgress || undefined, "aria-pressed": isPressed, className: C(styles.Container, disabled ? styles.ToggleDisabledColor : styles.ToggleColor), "data-test-state": state, "data-testid": ToggleTestIdFactory.getToggleTestId(testid), disabled: disabled, onClick: handleClick, type: "button", children: [label && labelPosition === LABEL_POSITIONS.LEFT && (_jsx(Typography, { color: "accent", "data-testid": ToggleTestIdFactory.getToggleLabelTestId(testid), kind: "generic", children: label })), _jsxs("div", { className: C(styles.Toggle, STATE_CLASS_MAP[state][availability], SIZE_CLASS_MAP[size]), children: [_jsx("div", { className: C(styles.Circle, CIRCLE_STATE_CLASS_MAP[state][availability], CIRCLE_SIZE_CLASS_MAP[size], CIRCLE_POSITION_CLASS_MAP[state][size]) }), state === TOGGLE_STATES.IN_PROGRESS && (_jsx(SpinnerIcon, { size: progressIconSize }))] }), label && labelPosition === LABEL_POSITIONS.RIGHT && (_jsx(Typography, { color: "accent", "data-testid": ToggleTestIdFactory.getToggleLabelTestId(testid), kind: "generic", children: label }))] }));
};
_react_refresh_temp_1 = Toggle;
$RefreshReg$(_react_refresh_temp_1, "Toggle");
_react_refresh_temp_2(Toggle, "uJvXKH8Ckg7wmK2eLukuzcLxJLM=");
